module.exports = "https://www.gc-pro.gnp.com.mx/8c2918f933b85bc31d5fce51284bbbf7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/eye-mascota.svg
// module id = 1819
// module chunks = 0